// extracted by mini-css-extract-plugin
export default {"cardContainer":"card_cardContainer__olUx5","cardh2":"card_cardh2__NINI4"};